import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonWarning from './person-warning-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonWarning {...validProps} />;
}

SvgComponent.iconName = 'personWarning';

export const PersonWarningIcon = svgIconWrapper(SvgComponent);
